var React = require('react');

function BurgerInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"menu_scroll","d":"M11266.149,1869a1.016,1.016,0,1,1,0-2.016h20.69a1.016,1.016,0,1,1,0,2.016Zm-.116-9.069a1.008,1.008,0,1,1,0-2.016h29.654a1.008,1.008,0,1,1,0,2.016Zm-.2-9.914a1.026,1.026,0,0,1,0-2.016h30.053a1.026,1.026,0,0,1,0,2.016Z","transform":"translate(-11265.001 -1848)","fill":"#fff"}));
}

BurgerInline.defaultProps = {"width":"31.722","height":"21","viewBox":"0 0 31.722 21"};

module.exports = BurgerInline;

BurgerInline.default = BurgerInline;
